import { useHttp } from './http';

const http = useHttp('disputes');

export default {
  escalateClaim: id => http.post(id, { action: 'escalate' }),
  resolveClaim: id => http.post(id, { action: 'resolve' }),
};
